import { render, staticRenderFns } from "./section-slogan.vue?vue&type=template&id=bf4b3c3a&"
import script from "./section-slogan.vue?vue&type=script&lang=js&"
export * from "./section-slogan.vue?vue&type=script&lang=js&"
import style0 from "./section-slogan.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports